// extracted by mini-css-extract-plugin
module.exports = {"cta":"_1hytwjIm","disabled":"_1ltHADqJ","primary":"_29cNDoxQ","transparent":"_1H3R2nsu","secondary":"_3Cq7iWY8","fullWidth":"aD_Cq2CU","small":"_1fyRbzPO","spinner":"_3WyLce6o"};